<!--
  SupportText.svelte — a plain-text support body, with its URLs made clickable.

  Message bodies are plain text written by customers and agents, so they are
  never rendered as HTML. Line breaks are kept with `whitespace-pre-wrap`, and
  URLs are split out by `linkifyText` and rendered as anchors whose `href` is the
  matched text itself — only `http:` and `https:` can match, so no body can
  produce a `javascript:` link. `break-words` stops one long URL from widening
  the thread past its column.
-->
<script lang="ts">
	import { linkifyText } from '../support/supportFormat';

	interface Props {
		/** The plain text to render. */
		text: string;
		/** Extra classes for the wrapper. */
		class?: string;
	}

	let { text, class: className = '' }: Props = $props();

	/** The body split into text and link runs. */
	let segments = $derived(linkifyText(text));
</script>

<div class="break-words whitespace-pre-wrap {className}">
	{#each segments as segment, index (index)}{#if segment.kind === 'link'}<a
				href={segment.text}
				target="_blank"
				rel="noopener noreferrer nofollow"
				class="text-primary-600 dark:text-primary-400 underline hover:no-underline">{segment.text}</a
			>{:else}{segment.text}{/if}{/each}
</div>
